<template>
  <div class="word">

    <div id="penduDef" class="flexwrap centercenter" v-if="!automaticDisplay">"{{definition}}"</div>
    <div id="penduDef" class="flexwrap centercenter" v-else>GAME OVER !</div>
    <div class="words">
      <transition name="fadethumb" mode="out-in">
        <span v-if="success" class="thumbs_up" :key="success"><i
            class="fas fa-star"></i></span>
      </transition>
      <div class="english lightTheme smallRoundAngles gigMarginRound smallPaddingRound blue">
        <div class="flex-wrap">
          <div class="englishWord" v-for="(word, index) in currentEnglish" :key="index * 1000">
            <div class="letter lightTheme verySmallRoundAngles" v-for="(letter, index) in word" :key="index">
              {{ letter }}
            </div>
          </div>
        </div>
      </div>

      <div class="french lightTheme smallRoundAngles gigMarginRound smallPaddingRound red">
        <div class="flex-wrap">
          <div class="frenchWord" v-for="(word, index) in currentFrench" :key="-index * 1000">
            <div class="letter lightTheme verySmallRoundAngles" v-for="(letter, index) in word" :key="-index -1">
              {{ letter }}
            </div>
          </div>
        </div>
      </div>

    </div>

    <keyboard26 class="keyboard"
        @letterSuggested="newLetter"
        :proposedLetters="letters">
    </keyboard26>
  </div>
</template>

<script>

import {mapGetters} from "vuex";

export default {
  name: "penduWord",

  components: {
    keyboard26: () => import(/* webpackPrefetch: true */ '@/components/keyboard26.vue')
  },

  props: {
    english: String,
    french: String,
    definition: String,
    automaticDisplay: Boolean
  },

  created() {
    // On remplace les accents etc... par les caractères normaux en majuscule
    this.englishUpper = this.slugify(this.english).toUpperCase();
    this.frenchUpper = this.french.toUpperCase();

    // On affiche par défaut tout ce qui n'est pas un des 26 characters de base, après slugifycation
    Array.from(this.frenchUpper).forEach((element, index) => {
      console.log(this.slugify(element))
      if(this.slugify(element).toUpperCase().charCodeAt(0) >= 65 && this.slugify(element).toUpperCase().charCodeAt(0) <= 65+26) {
        this.currentFrench.push("_")
      }

      else {
        this.currentFrench.push(element);
      }
    });

    Array.from(this.englishUpper).forEach((element, index) => {
      if(element.charCodeAt(0) >= 65 &&element.charCodeAt(0) <= 65+26) {
        this.currentEnglish.push("_")
      }

      else {
        this.currentEnglish.push(element);
      }
    })

    // Il faut maintenant séparer les mots en segments en repérant les espaces potentiels
    this.currentFrench = this.splitSpaces(this.currentFrench);
    this.currentEnglish = this.splitSpaces(this.currentEnglish);

    window.addEventListener('keypress', this.keyboardPress);
  },

  destroyed() {
    window.removeEventListener('keypress', this.keyboardPress);
  },

  computed: {
    ...mapGetters('global', [
      'isMobile',
    ]),
  },

  watch: {
    'automaticDisplay': function() {
      if(this.automaticDisplay) {
        this.englishUpper.split(' ').forEach((word, indexWord) => {
          word.split("").forEach((letter, indexLetter) => {
            this.currentEnglish[indexWord][indexLetter] = letter;
          })
        })

        this.frenchUpper.split(' ').forEach((word, indexWord) => {
          word.split("").forEach((letter, indexLetter) => {
            this.currentFrench[indexWord][indexLetter] = letter;
          })
        })
      }
    }
  },

  methods: {
    splitSpaces(array) {
      //Le nouvel array d'array à construire
      let tempArray = []
      let spacesPos = [];
      array.forEach((element, index, arr) => {
        if(element == ' ') {
          spacesPos.push(index);
        }
      })

      if(spacesPos.length === 0) {
        tempArray.push(array)
      }
      else {
        let previousPos = 0
        spacesPos.forEach((element, index, arr) => {
          tempArray.push(array.slice(previousPos, element));
          previousPos = element+1;
          // Si on a passé en revu le dernier espace, on ajoute le dernier tronçon au tableau
          if(index >= arr.length -1) {
            tempArray.push(array.slice(previousPos));
          }
        })
      }

      return tempArray
    },

    keyboardPress(event) {
      if(this.slugify(String.fromCharCode(event.keyCode)).toUpperCase().charCodeAt(0) >= 65 && this.slugify(String.fromCharCode(event.keyCode)).toUpperCase().charCodeAt(0) <= 65+26) {
        this.newLetter(this.slugify(String.fromCharCode(event.keyCode)).toUpperCase())
      }
    },

    newLetter(letter) {
      let isNew = true;
      // Si la lettre a déjà été proposée, on ne fait rien
      this.letters.forEach((element) => {
        if(element.letter === letter) {
          isNew = false;
        }
      })

      if(isNew) {
        let success = true;
        let status = "red";
        let tempEnglishUpper = this.englishUpper.split(' ');
        let tempFrenchUpper = this.frenchUpper.split(' ');

        tempEnglishUpper.forEach((word, wordIndex) => {
          Array.from(word).forEach((currentLetter, letterIndex) => {
            if(currentLetter == letter) {
              this.currentEnglish[wordIndex][letterIndex] = currentLetter;
              status = "blue";
            }
            if(this.currentEnglish[wordIndex][letterIndex] == '_') {
              success = false;
            }
          })
        })

        tempFrenchUpper.forEach((word, wordIndex) => {
          Array.from(word).forEach((currentLetter, letterIndex) => {
            if(this.slugify(currentLetter).toUpperCase() == letter) {
              this.currentFrench[wordIndex][letterIndex] = currentLetter;
              status = "blue";
            }
            if(this.currentFrench[wordIndex][letterIndex] == '_') {
              success = false;
            }
          })
        })

        this.letters.push({
          'letter': letter,
          'status': status
        });

        if(status === "red") {
          this.$emit('hpLoss', this.hpChange.wrongLetter)
        }

        else if(status === "blue") {
          this.$emit('hpGain', this.hpChange.goodLetter)
        }

        if(success) {
          this.$emit('wordGuessed', this.hpChange.wordGuessed)
          this.success = true;
          window.setTimeout(() => (this.success = false), 10);
        }
      }
    },

    slugify(str) {
      const map = {
        'a' : 'á|à|ã|â|ä|À|Á|Ã|Â|Ä',
        'e' : 'é|è|ê|ë|É|È|Ê|Ë',
        'i' : 'í|ì|î|ï|Í|Ì|Î|Ï',
        'o' : 'ó|ò|ô|õ|ö|Ó|Ò|Ô|Õ|Ö',
        'u' : 'ú|ù|û|ü|Ú|Ù|Û|Ü',
        'c' : 'ç|Ç',
        'n' : 'ñ|Ñ',
        'oe' : 'œ'
      };

      for (var pattern in map) {
        str = str.replace(new RegExp(map[pattern], 'g'), pattern);
      }

      return str;
    },
  },

  data() {
    return {
      hpChange: {
        wrongLetter: -9,
        goodLetter: 2.5,
        wordGuessed: 12
      },
      englishUpper: '',
      frenchUpper: '',
      currentEnglish: [],
      currentFrench: [],
      letters: [],
      success: false,
    }
  }
}
</script>

<style scoped>
  .word {
    position: relative;
    display: grid;
    grid-template-rows: 1fr auto 1fr;
    height: 100%;
    justify-items: center;
    align-items: center;
    justify-content: space-between;

  }

  #penduDef{
    font-size: 1.6em;
    font-style: italic;
    text-align: center;
  }

  .words {
    display: flex;
    margin-top: auto;
    margin-bottom: auto;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }

  .english {
    display: flex;
    flex-direction: column;
    justify-items: flex-start;
    align-items: center;
  }

  .french {
    display: flex;
    flex-direction: column;
    justify-items: flex-start;
    align-items: center;
  }

  .englishWord {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
  }

  .frenchWord {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
  }

  .keyboard {
    width: 50%;
    align-self: flex-end;
  }

  .lettersList {
    width: 50%;
    display: flex;
    align-self: center;
  }

  .letter {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0.2vw;
    width: 2vw;
    height: 2vw;
    font-weight: bold;
  }

  .thumbs_up {
    position: absolute;
    /*height: 150%;*/
    align-content: center;
    font-size: 150%;
    color: #59daff;
  }


  .redLetter {
    color: #5b0b0b;
  }


  .fadethumb-leave-active {
    transition: all 1.5s;
    -webkit-transition: all 1.5s;
    -ms-transition: all 1.5s;
  }

  .fadethumb-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
    transform: translateY(-2vw);
  }

  @media screen and (max-device-width: 767px) {
    .letter {
      margin: 0.5vw;
      width: 8vw;
      height: 8vw;
    }

    .words {
      flex-grow: 1;
      flex-direction: column;
      justify-content: space-evenly;
    }
    .keyboard {
      width: 100%;
      align-self: center;
    }
  }
</style>